export default __webpack_public_path__ + "static/media/Incidents-2.669e28f9.png";